import React from 'react';
import classes from './HandlingUserData.module.css';

const de = (props) => (
  <div className={classes.Content}>
    {props.indexPage
      ? <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}><b>Daten herunterladen</b></p>
        <p>Um Ihre Daten herunterzuladen, gehen Sie auf die folgende Seite<br />
          Einstellungen > Optionen > Datenverwaltung > Daten herunterladen
        </p><br />
        <div className={classes.HrLine} />
        <br />
      </div>
      : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}><b>Datenlöschung anfordern</b></p><br />
    <p>Führen Sie die folgenden Schritte aus, um die Löschung von Daten zu beantragen:</p><br />
    <p>Gehen Sie zur Kontaktseite <br />
      Wählen Sie die Option "Konto und alle meine Daten löschen." <br />
      Drücken Sie Senden <br /><br />
    </p>
    <p>Unser CS-Team wird innerhalb von 24 Stunden alle Ihre Daten löschen.</p>
  </div>
);

export default de;



// WEBPACK FOOTER //
// ./src/assets/localization/hud/de.js